// export const BASE_URL = "https://0a198d37427b.ngrok-free.app";
export const BASE_URL = "https://confluence-bot-app.herokuapp.com";
export const CRYPTO_KEY = "122BOTConfluence";
export const CONFLUENCES_USERS = "/ebs/confluence-users";
export const CONFLUENCES_USER = "/ebs/confluence-user";
export const LOGIN = "/ebs/confluence-users/sign-in";
export const CONFLUENCE_USER_EVENTS = "/ebs/confluence-users/events";
export const CONFLUENCE_VENDORS = "/ebs/confluence-vendors";
export const CONFLUENCE_ORDERS = "/ebs/confluence-orders";
export const CONFLUENCE_VENDORS_CLIENTS = `${CONFLUENCE_VENDORS}/clients`;
export const CONFLUENCE_NOTIFICATIONS = "/ebs/confluence-notification";
export const DECORATIONS = "/ebs/confluence-decorations";
export const PRINT_PROVIDERS = "/ebs/confluence-print-providers";
export const COMMENTS = "/ebs/confluence-orders-comments";
export const APP_VERSION = "/ebs/update-app-version";
export const CONFLUENCE_PURCHASE_ORDER = "/ebs/confluence-purchase-order";
export const CONFLUENCE_SCAN_PURCHASE_ORDER = "/ebs/scan-purchase-order";
export const CONFLUENCE_OTHER_CHARGES = "/ebs/confluence-other-charges";
export const QUICK_BOOKS_PDF_GENERATION = "/ebs/quickBooks-estimate-pdf";
export const QUICK_BOOKS_CUSTOMER = "/ebs/quickBooks-customers";
export const QUICK_BOOKS_ITEMS = "/ebs/quickBooks-items";
export const QUICK_BOOKS_SALES_CODE = "/ebs/quickBooks-sales-codes";
export const QUICK_BOOKS_INVOICE = "/ebs/quickBooks-invoice";
export const QUICK_BOOKS_REFRESH_TOKEN = "/ebs/qbRefresh";
export const QUICK_BOOKS_CA_AUTH_REQUEST = "/ebs/qbCAAuthRequest";
export const QUICK_BOOKS_US_AUTH_REQUEST = "/ebs/qbUSAuthRequest";
export const VENDORS_SERVICE = "/ebs/confluence-vendors";
export const VENDOR_USERS = "/ebs/confluence-vendor-users";
export const ORDERS_CHECK_IN = "/ebs/confluence-orders-checkin";
export const ORDERS_DAMAGE = "/ebs/confluence-orders-damage";
export const BOT_NETWORK_USERS = "/ebsnetwork/users";
export const CONFLUENCE_DECORATIONS = "/ebs/confluence-decorations";
export const DECORATOR_COMMENTS = "/ebsnetwork/orders-decorator-comments";
export const CONFLUENCE_CUSTOMER_REQUEST = "/ebs/confluence-customer/request";
export const CONFLUENCE_CUSTOMER_REQUEST_REPLY =
  "/ebs/confluence-customer/request-reply";
export const CONFLUENCE_VENDORS_USER_LIST = "/ebs/confluence-vendors-userList";
export const IMS_RETAIL_ORDERS = "/ebs/confluence-orders/IMSRetail/Orders";
export const IMS_RETAIL_LOGOS = "/ebs/confluence-orders/IMSRetail/Logos";
export const IMS_RETAIL_ORDER_EVENTS =
  "/ebs/confluence-orders/IMSRetail/OrderEvents";
export const TRACKING_NUMBER_US = "/ebs/confluence-orders/getTrackingUSNumber";
export const ADMIN_ORDER_UPDATE = "/ebs/confluence-orders-admin-update";
export const ADMIN_ORDER_FILE_UPDATE =
  "/ebs/confluence-orders-admin-file-update";
export const STOCK_STATUS = "/ebs/stock-status";
export const INFORM_STOCK_STATUS = "/ebs/inform-stock-status";
